import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import api from "~/services/api";
import { Label, Input, Select } from "~/componentes/CustomForm";

import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CreateEditContent({ mountedData, unidades }) {
  const [ativo, setAtivo] = useState(!mountedData ? "true" : mountedData?.ativo ? "true" : "false");
  const [habilitadoQRCode, setHabilitadoQRCode] = useState(!mountedData ? "S" : mountedData?.habilitadoQRCode);
  const [idAcesso, setIdAcesso] = useState(mountedData?.idAcesso);
  const [senhaAcesso, setSenhaAcesso] = useState(mountedData?.senhaAcesso);
  const [idUnidade, setIdUnidade] = useState(mountedData?.idUnidade);
  const [idCentroCusto, setIdCentroCusto] = useState(mountedData?.idCentroCusto);
  const [centroCustos, setCentroCustos] = useState([]);
  const [pesquisas, setPesquisas] = useState([]);
  const [imprimePDF, setImprimePDF] = useState(false);

  useEffect(() => {
    // api
    //   .get('/signed/cliente/gestorservico/gerenciamento/centroCustos', { params: { ativo: 1 } })
    //   .then(response => setCentroCustos(response.data));
    api
      .get('/signed/cliente/pesquisa/gerenciamento/pesquisas', { params: { ativo: 1 } })
      .then(response => setPesquisas(response.data));
  }, []);

  useEffect(() => {
    if (unidades?.length > 0) {
      if (!idUnidade) {
        setIdUnidade(unidades[0]?.id);
        setCentroCustos(unidades[0]?.centroCustos);
      } else {
        let itemUnidade = unidades?.find((item) => item?.id == idUnidade);
        if (itemUnidade) {
          setIdUnidade(itemUnidade?.id);
          setCentroCustos(itemUnidade?.centroCustos);
        }
      }
    }
  }, [unidades]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
          idUnidade,
          idCentroCusto,
          tipo: "S",
        }
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/cliente/gestorservico/gerenciamento/dispositivo", thisData);
        else
          response = await api.post("/signed/cliente/gestorservico/gerenciamento/dispositivo", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} esse Dispositivo, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} esse Dispositivo?`,
        successModal: `Dispositivo ${mountedData?.id ? "atualizado" : "cadastrado"} com sucesso!`,
      }
    );
  }

  useEffect(() => {
    if (imprimePDF) {
      setImprimePDF(false);
      let conteudo = document.getElementById('qrcodeimp').innerHTML;
      let tela_impressao = window.open('about:blank');

      tela_impressao.document.write(conteudo);
      tela_impressao.window.print();
      tela_impressao.window.close();
    }
  }, [imprimePDF]);

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios</p>
        </div>
        <div className="row">
          <Label title="Título *" className="col s4 m4 l4">
            <Input name="titulo" required="true" defaultValue={mountedData?.titulo} />
          </Label>
          <Label title="Codigo Device *" className="col s2 m2 l2">
            <Input name="codigoDevice" maxLength="10" required="true" defaultValue={mountedData?.codigoDevice} />
          </Label>
          <Label title="Unidade *" className="col s6 m6 l2">
            <Select
              isString
              list={{ list: unidades, value: "id", label: "titulo" }}
              name="idUnidade"
              defaultValue={idUnidade}
              onChange={(e) => {
                const v = e.currentTarget.value || 0;
                setIdUnidade(v);

                const itemUni = unidades?.find((p) => p?.id == v);
                if (itemUni) {
                  setCentroCustos(itemUni?.centroCustos);
                }
              }}
            />
          </Label>
          <Label title="Centro de Custo *" className="col s2 m2 l2">
            <Select
              isNumber
              list={{ list: centroCustos, value: 'id', label: 'titulo' }}
              name="idCentroCusto"
              firstOption
              required="true"
              defaultValue={idCentroCusto}
              onChange={(e) => {
                const v = e.currentTarget.value || 0;
                setIdCentroCusto(v);
              }}
            />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <Select
              isString
              list={{ list: [{ id: "true", titulo: "Sim" }, { id: "false", titulo: "Não" }], value: "id", label: "titulo" }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={(e) => {
                const v = e.currentTarget.value || "true";
                setAtivo(v);
              }}
            />
          </Label>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
